// import enums
import { EndOfEmploymentSettlementEnums } from 'components/admin-portal/CLA/CLASettings/CLASettings.enums';
import { settlementPrefixMap } from './SelectSettlementType.enums';

export const buildDutyCodeKey = (
  settlementType: keyof typeof EndOfEmploymentSettlementEnums | undefined,
  fieldName: string
) => {
  if (!settlementType) return undefined;
  const prefix = settlementPrefixMap[settlementType];
  return (
    prefix + fieldName.charAt(0).toUpperCase() + fieldName.slice(1) + 'Type'
  );
};
